import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { MainService } from 'src/app/core/_services/main.service';

@Component({
  selector: 'app-image-include',
  templateUrl: './image-include.component.html',
  styleUrls: ['./image-include.component.scss']
})
export class ImageIncludeComponent implements OnInit {

  constructor(private service: MainService, private loader: NgxUiLoaderService, public dialogRef: MatDialogRef<ImageIncludeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }
  imageIncludeEstimateList: any[] = [];
  checkedEstimate: any[] = [];

  ngOnInit(): void {
    this.imageIncludeEstimateList = this.data.allEstimate.filter((x: any) =>
      x?.images?.length > 0
    );
    this.checkedEstimate = this.imageIncludeEstimateList
      .filter(estimate => !estimate.noData)
      .map(estimate => estimate._id);
  }

  inspectionBtn: any = []
  getDefaultStatus() {
    this.service.get({}, `${API_ROUTES.OPPORTUNITY.getInspectionBtnStatus}`).pipe().subscribe(response => {
      this.loader.start();
      if (response.status) {
        this.inspectionBtn = response.data?.list;
      }
      this.loader.stop();
    })
  }

  setInspectionStatus(id: number): string {
    console.log(id);
    const foundBtn = this.inspectionBtn?.find(ele => ele?._id === id);
    console.log(foundBtn, 'nwknkjwn')
    if (foundBtn) {
      // Apply class based on originalName
      switch (foundBtn.originalName) {
        case 'Fail':
          return 'red-btn';
        case 'Pass':
          return 'pass-status';
        case 'Pending':
          return 'pend-status';
        case 'N/A':
          return 'grey-btn';
        default:
          return '';
      }
    } else {
      return ''; // Default class if no button is found
    }
  }

  initEstimateSelection(): void {
    this.checkedEstimate = this.imageIncludeEstimateList
      .filter(estimate => !estimate.noData)
      .map(estimate => estimate._id);
  }

  estimateChecked(id: any): void {
    const index = this.checkedEstimate.indexOf(id);
    if (index === -1) {
      this.checkedEstimate.push(id);
    } else {
      this.checkedEstimate.splice(index, 1);
    }
  }

  isAllChecked(): boolean {
    const validIds = this.imageIncludeEstimateList
      .filter(estimate => !estimate.noData)
      .map(estimate => estimate._id);
    return validIds.length > 0 && validIds.every(id => this.checkedEstimate.includes(id));
  }

  toggleAll(event: any): void {
    const validIds = this.imageIncludeEstimateList
      .filter(estimate => !estimate.noData)
      .map(estimate => estimate._id);

    if (event.target.checked) {
      // select all that aren't already selected
      validIds.forEach(id => {
        if (!this.checkedEstimate.includes(id)) {
          this.checkedEstimate.push(id);
        }
      });
    } else {
      // unselect all
      this.checkedEstimate = this.checkedEstimate.filter(id => !validIds.includes(id));
    }
  }

  download() {
    this.dialogRef.close({
      approved: [...this.checkedEstimate]
    })
  }
}
